import React, { useState } from "react";
import Footer from "../components/Shared/Footer";

import { sendContactUs } from "../api/utils";
import Swal from "sweetalert2";

const ContactUs = () => {
    const [formData, setFormData] = useState({
        from_email: '',
        full_name: '',
        mobile: '',
        subject: '',
        message: ''
    });
    const [isProcessing, setIsProcessing] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsProcessing(true);
        
        try {
            await sendContactUs(formData);
            
            // Show success popup
            Swal.fire({
                icon: 'success',
                title: 'Thank You!',
                text: 'Your message has been sent successfully. We will get back to you soon.',
                confirmButtonColor: '#75c043'
            });

            // Clear form
            setFormData({
                from_email: '',
                full_name: '',
                mobile: '',
                subject: '',
                message: ''
            });

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong! Please try again.',
                confirmButtonColor: '#75c043'
            });
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div>
            <section className="breadcrumb-section pt-0">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-contain">
                                <h2>Contact Us</h2>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <a href="/">
                                                <i className="fa-solid fa-house"></i>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item active">Contact Us</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="contact-box-section">
                <div class="container-fluid-lg">
                    <div className="row g-lg-5 g-3">
                        <div className="col-lg-6">
                            <div className="left-sidebar-box">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="contact-image">
                                            <img src="../assets/images/inner-page/contact-us.png"
                                                className="img-fluid blur-up lazyloaded" alt=""/>
                                        </div>
                                    </div>
                                    <div className="col-xl-12">
                                        <div className="contact-detail">
                                            <div className="row g-4">
                                                <div className="col-12">
                                                    <div className="contact-detail-box">
                                                        <div className="contact-icon">
                                                            <i className="fa-solid fa-phone"></i>
                                                        </div>
                                                        <div className="contact-detail-title">
                                                            <h4>Call us</h4>
                                                        </div>

                                                        <div className="contact-detail-contain">
                                                            <p>(+91) 82912 70521</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="contact-detail-box">
                                                        <div className="contact-icon">
                                                            <i className="fa-solid fa-envelope"></i>
                                                        </div>
                                                        <div className="contact-detail-title">
                                                            <h4>Email</h4>
                                                        </div>

                                                        <div className="contact-detail-contain">
                                                            <p>wecare@zantuslifesciences.com</p>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-12">
                                                    <div className="contact-detail-box">
                                                        <div className="contact-icon">
                                                            <i className="fa-solid fa-building"></i>
                                                        </div>
                                                        <div className="contact-detail-title">
                                                            <h4>Address</h4>
                                                        </div>

                                                        <div className="contact-detail-contain">
                                                            <p>14, S G Barve Road, Opposite Kamgar Nagar, Chembur, Mumbai - 71, India</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="title d-xxl-none d-block">
                                <h2>Contact Us</h2>
                            </div>
                            <div className="right-sidebar-box">
                                <form className="row g-4" onSubmit={handleSubmit}>
                                    <div className="col-xxl-6 col-lg-12 col-sm-6">
                                        <div className="mb-md-4 mb-3 custom-form">
                                            <label htmlFor="full_name" className="form-label">Full Name</label>
                                            <div className="custom-input">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    id="full_name"
                                                    name="full_name"
                                                    placeholder="Enter Full Name"
                                                    value={formData.full_name}
                                                    onChange={handleInputChange}
                                                    required 
                                                />
                                                <i className="fa-solid fa-user"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xxl-6 col-lg-12 col-sm-6">
                                        <div className="mb-md-4 mb-3 custom-form">
                                            <label htmlFor="from_email" className="form-label">Email Address</label>
                                            <div className="custom-input">
                                                <input 
                                                    type="email" 
                                                    className="form-control" 
                                                    id="from_email"
                                                    name="from_email"
                                                    placeholder="Enter Email Address"
                                                    value={formData.from_email}
                                                    onChange={handleInputChange}
                                                    required 
                                                />
                                                <i className="fa-solid fa-envelope"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xxl-6 col-lg-12 col-sm-6">
                                        <div className="mb-md-4 mb-3 custom-form">
                                            <label htmlFor="mobile" className="form-label">Phone Number</label>
                                            <div className="custom-input">
                                                <input 
                                                    type="tel" 
                                                    className="form-control" 
                                                    id="mobile"
                                                    name="mobile"
                                                    placeholder="Enter Your Phone Number"
                                                    maxLength="10"
                                                    value={formData.mobile}
                                                    onChange={handleInputChange}
                                                    required 
                                                />
                                                <i className="fa-solid fa-mobile-screen-button"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xxl-6 col-lg-12 col-sm-6">
                                        <div className="mb-md-4 mb-3 custom-form">
                                            <label htmlFor="subject" className="form-label">Subject</label>
                                            <div className="custom-input">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    id="subject"
                                                    name="subject"
                                                    placeholder="Enter Subject"
                                                    value={formData.subject}
                                                    onChange={handleInputChange}
                                                    required 
                                                />
                                                <i className="fa-solid fa-paper-plane"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="mb-md-4 mb-3 custom-form">
                                            <label htmlFor="message" className="form-label">Message</label>
                                            <div className="custom-textarea">
                                                <textarea 
                                                    className="form-control" 
                                                    id="message"
                                                    name="message"
                                                    placeholder="Enter Your Message"
                                                    rows="6"
                                                    value={formData.message}
                                                    onChange={handleInputChange}
                                                    required
                                                ></textarea>
                                                <i className="fa-solid fa-message"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <button 
                                        type="submit" 
                                        className="btn btn-animation btn-md fw-bold ms-auto" 
                                        style={{width: "200px"}}
                                        disabled={isProcessing}
                                    >
                                        {isProcessing ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Sending...
                                            </>
                                        ) : (
                                            "Send Message"
                                        )}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div>
                <Footer />
            </div>
        </div>
    );
};

export default ContactUs;
